import React from "react";
import { isEmpty, startCase } from "lodash";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { BsArrowUpShort } from "react-icons/bs";

const SupportList = ({ supportList, page, sort, setSort }) => {
  const { t } = useTranslation();

  return (
    <div className="p-3">
      <div className="overflow-x-auto relative rounded-lg border">
        <table className="w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 ">
          <thead className="text-xs text-gray-900 border border-[#E1E6EE]  bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
            <tr>
              <th scope="col" className="py-3 px-6">
                Sr no.
              </th>
              <th scope="col" className="py-3 px-6">
                {t("O_NAME")}
              </th>
              <th scope="col" className="py-3 px-6">
                {t("EMAIL_ID")}
              </th>
              <th
                scope="col"
                className="py-3 px-6 cursor-pointer"
                onClick={() => {
                  if (sort.sortBy === "createdAt" && sort.sortType === "asc") {
                    setSort({
                      sortBy: "createdAt",
                      sortType: "desc",
                    });
                  } else {
                    setSort({
                      sortBy: "createdAt",
                      sortType: "asc",
                    });
                  }
                }}
              >
                <div className="flex">
                  <span>{t("CREATED_DATE")}</span>
                  <span>
                    {sort.sortBy === "createdAt" && sort.sortType === "asc" && <BsArrowUpShort className="w-4 h-4" />}
                    {sort.sortBy === "createdAt" && sort.sortType === "desc" && <BsArrowUpShort className="w-4 h-4 rotate-180" />}
                  </span>
                </div>
              </th>
              <th scope="col" className="py-3 px-6">
                {t("O_STATUS")}
              </th>
              <th scope="col" className="py-3 px-6">
                {t("DESCRIPTION")}
              </th>
              <th scope="col" className="py-3 px-6">
                {t("ADMIN_REPLY")}
              </th>
              <th scope="col" className="py-3 px-6">
                {t("ADMIN_REPLY_DATE")}
              </th>
            </tr>
          </thead>
          <tbody>
            {supportList &&
              supportList?.map((item, i) => (
                <tr key={i} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                  <th scope="row" className="py-4 px-6 border-r font-medium text-gray-900  dark:text-white">
                    {i + 1 + 10 * (page - 1)}
                  </th>
                  <td className="py-4 px-6 border-r text-gray-900">{item?.name}</td>
                  <td className="py-4 px-6 border-r text-gray-900">{item?.email}</td>
                  <td className="py-4 px-6 border-r text-gray-900 ">{dayjs(item?.createdAt).format("MM-DD-YYYY hh:mm A")}</td>
                  <td className="py-4 px-6 border-r text-gray-900">{startCase(item?.status === "replied" ? "Closed" : "Pending")}</td>
                  <td className="py-4 px-6 border-r text-gray-900">{item?.description}</td>
                  <td className="py-4 px-6 border-r text-gray-900">{item?.adminReply || "Not Replied"}</td>
                  <td className="py-4 px-6 border-r text-gray-900 ">{item?.adminReplyDate ? dayjs(item?.adminReplyDate).format("MM-DD-YYYY hh:mm A") : "Not Replied"}</td>
                </tr>
              ))}
            {isEmpty(supportList) ? (
              <tr className="bg-white text-center border-b dark:bg-gray-800 dark:border-gray-700">
                <td className="py-4 px-6 border-r" colSpan={10}>
                  {t("O_NO_RECORD_FOUND")}
                </td>
              </tr>
            ) : null}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SupportList;
